import { render, staticRenderFns } from "./OngletAccess.vue?vue&type=template&id=f6dd7ac2"
import script from "./OngletAccess.vue?vue&type=script&lang=js"
export * from "./OngletAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports